import { Link } from 'react-router-dom';

const ILOSPanel = () => {
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>Billing</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<h2>Billing</h2>
				<div className="divider" />
				<ul className="text-lg menu">
					<li>
						<Link className="link" to="/ilos-panel/credentialed-services">
							Credentialed Services
						</Link>
					</li>
					<li>
						<Link className="link" to="/ilos-panel/invoicing">
							Invoicing
						</Link>
					</li>
					<li>
						<Link className="link" to="/ilos-panel/export">
							Completed Report Export
						</Link>
					</li>
				</ul>
			</div>
		</>
	);
};

export default ILOSPanel;
